import { Tabs } from 'eymp-uicomps';
import React from 'react';
import { Grid } from '@material-ui/core';
import './TabComponent.scss';
import ToggleWithLabels from 'src/new-ui/library/ToggleWithLabels';
import Filter from '../Filter';
import Searchbar from '../SearchBar/Searchbar';
import BadgeWithCloseButton from 'src/new-ui/library/BadgeWithCloseButton/BadgeWithCloseButton.js';
import _ from 'lodash';

export class TabComponent extends React.Component {
  state = {
    pillFilter: {},
    filtersDataResponse: null,
    localApplicationTypeResponse: null,
  };

  constructor(props) {
    super(props);
    this.filterRef = React.createRef();
  }

  getPillComponent = () => {
    let PillComponent = [];
    if (this.state.pillFilter) {
      for (let [key, value] of Object.entries(this.state.pillFilter)) {
        let displayText = '';

        switch (key) {
          case 'policy': {
            const policy = this.state.filtersDataResponse.policies;
            value = _.find(policy, e => e.id === value).name;
            displayText = 'Policy';
            break;
          }
          case 'service': {
            const service = this.state.filtersDataResponse.services;
            value = _.find(service, e => e.id === value).name;
            displayText = 'Service';
            break;
          }
          case 'createdDate': {
            displayText = 'Created Date';
            break;
          }
          case 'targetDateStart': {
            displayText = 'Target Date Start';
            break;
          }
          case 'targetDateEnd': {
            displayText = 'Target Date End';
            break;
          }
          case 'hostCountry': {
            const hostCountry = this.state.filtersDataResponse.countries;
            value = _.find(hostCountry, e => e.id === value).name;
            displayText = 'Case Country';
            break;
          }
          case 'homeCountry': {
            const homeCountry = this.state.filtersDataResponse.countries;
            value = _.find(homeCountry, e => e.id === value).name;
            displayText = 'Home Country';
            break;
          }
          case 'applicationType': {
            if (value !== undefined) {
              const applicationType = this.state.localApplicationTypeResponse;
              value = _.find(applicationType, e => e.ey_applicationtypeid === value).ey_name;
              displayText = 'Local Application Type';
            }
            break;
          }
          default: {
          }
        }

        if (value !== undefined) {
          PillComponent.push(
            <BadgeWithCloseButton labelLeft={key} labelRight={value} displayText={displayText} onClickTest={this.handlePillClick} />,
          );
        }
      }
      return PillComponent;
    }
  };

  handlePillClick = key => {
    let removeFromPill = this.state.pillFilter;
    delete removeFromPill[key];
    this.setState(
      prevState => ({
        pillFilter: removeFromPill,
      }),
      () => {
        if (this.props.handlePillClear) {
          this.props.handlePillClear(key);
        }
        if (this.filterRef && this.filterRef.current) {
          this.filterRef.current.clearFilterByKey(key);
        }
      },
    );
  };

  setFilter = filter => {
    this.setState({ pillFilter: filter });
  };

  setFilterDataResponse = response => {
    this.setState({ filtersDataResponse: response });
  };

  setApplicationTypeResponse = response => {
    this.setState({ localApplicationTypeResponse: response });
  };

  onAllPillClear = () => {
    this.setState({ pillFilter: {} });
    if (this.filterRef && this.filterRef.current) {
      this.filterRef.current.clearAllFilter();
    }
  };

  render() {
    return (
      <Grid>
        {/* <Grid item className="panel-search-container">
        <div className="d-flex">
          <Filter /> <Searchbar />
        </div>
      </Grid> */}
        <Grid item className="tab-component">
          <div
            style={{
              background: 'white',
            }}>
            <div className="d-flex panel-search-container">
              <Filter
                ref={this.filterRef}
                onSetFilter={this.setFilter}
                onFilterResponse={this.setFilterDataResponse}
                onApplicationTypeResponse={this.setApplicationTypeResponse}
                onAllPillClear={this.onAllPillClear}
                onChange={this.props.onApplyFilter}
                onClearFilter={this.props.onClearFilter}
              />{' '}
              <Searchbar onSearch={this.props.onFilterSearch} />
            </div>

            {/* comenting pill filter till further notice */}
            {/* {this.getPillComponent()} */}

            <div className="tabs-filter-block">
              <Tabs
                tabs={this.props.tabs1}
                handleOnChange={this.props.onChange}
                defaultTabIndex={this.props.defaultTabIndex}
                className={this.props.isApplicant ? 'tab-width' : ''}
              />
              {!this.props.isApplicant && (
                <Grid className="toggle-spacing">
                  <ToggleWithLabels
                    onLabel="All cases"
                    offLabel="My cases"
                    onChange={e => this.props.toggleChange(e)}
                    switchSelected={this.props.switchSelected}
                  />
                </Grid>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default TabComponent;
